import React, { Component, Fragment } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import {hit} from '../../metrics';
import CaseFooterNew from '../CaseFooterNew';
import HelmetSite from '../HelmetSite';
import './style.css';
import "../../../../node_modules/swiper/swiper-bundle.min.css";

class Qualle extends Component{
  swiperRef = React.createRef();
  swiperRef2 = React.createRef();
  state = {
		preview: true,
		play: false,
		mobile: window.innerWidth <= 1000
	};

	resize = () => this.setState({mobile: window.innerWidth <= 1000})

	componentDidMount(){

    window.addEventListener('scroll', this.handleScroll);

    var video = document.getElementById("video");
    $(".videoBlock__btn").click(function () {
      $(".videoBlock__btn").toggleClass("videoBlock__btn_hidden");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
		if(this.props.pathname == '/projects/quall-e/'){
			this.setState({preview: false});
			this.props.setProjectName('quall-e');
			$('body').addClass('case-expanded hash-quall-e');
			$(window).scrollTop($('#case-quall-e').offset().top);
			this.props.changeCase(null);
		}
		else{
			this.setState({preview: true});
			$('body').removeClass('hash-quall-e');
    }
    window.scrollTo(0, 0);
    hit(window.location.pathname);


    setTimeout(() => {
			$('body').addClass('fadepage');
    }, 100);
	}

	componentDidUpdate(){
		if(this.props.pathname == '/projects/'){
			$('body').removeClass('case-expanded hash-quall-e');
		}
  }

  componentWillUnmount() {
    $('body').removeClass('fadepage');
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    let height = $(window).height()/2
    let scroll = $(document).scrollTop() + height;
    let top =  $('.gridChild2__item_2').offset().top;
    if(scroll >= top){
      $('.bubbles').addClass('animate');
    }
  }
  
	render(){
		return(
		<div className='case'>
			<div className="case-content" id="case-quall-e">

        <div className="screen">
          <div className="topScreen">
            <div className="topScreen__bg" style={{backgroundImage: `url('/cases/img/quall-e/bg-top.webp')`}} />
            <div className="topScreen__title"><img src="/cases/img/quall-e/logo.svg" alt="" /></div>
          </div>
          <div className="aboutProject">
            <div className="content">
              <div className="aboutProject__wrap">
                <div className="aboutProject__left">
                  <div className="aboutProject__title title">AI ассистент “Quall-e”</div>
                  <div className="aboutProject__desc">
                    <div>
                      <div>Клиент</div>
                      <div>Quall-e</div>
                    </div>
                    <div>
                      <div>Виды&nbsp;работ</div>
                      <div>
                        <div className="tabs">
                          <div>Фирменный&nbsp;стиль</div>
                          <div>Сайт</div>
                        </div>
                      </div>
                    </div>            
                  </div>          
                </div>
                <div className="aboutProject__text text">
                  AI ассистент Quall–e станет вашим надежным помощником в&nbsp;поиске и&nbsp;отборе клиентов в&nbsp;недвижимости, освобождая для вас время на&nbsp;другие задачи!
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="screen workType">
          <div className="content">
            <div className="workType__wrap">
              <div className="workType__title title">Фирменный стиль</div>
              <div className="workType__desc text">
                Фирменный стиль строится на простоте, минимализме и универсальности. Ключевой элемент — большая оранжевая точка, которая может быть узором, мячом или шариком. Она объединяет части написания и отсылает к Wall-e, но в обновлённой, неочевидной форме.
                <br/><br/>
                Мы не используем образ робота или маскота, сохраняя идею гибкости и изменчивости знака. Это важно, поскольку наш продукт серьёзен и ориентирован на бизнес, а не на игровую тематику.
              </div>
            </div>
          </div>
        </div>
        <div className="screen">
          <div className="gridBox gridBox_style">
            <div className="gridBox__item gridBox__item_1">
              <div className="gridChild">
                <div className="gridChild__item gridChild__item_1" style={{backgroundImage: `url('/cases/img/quall-e/circle.svg')`}}></div>
                <div className="gridChild__item gridChild__item_2" style={{backgroundImage: `url('/cases/img/quall-e/img1.svg')`}}></div>             
              </div>
            </div>
            <div className="gridBox__item gridBox__item_2" style={{backgroundImage: `url('/cases/img/quall-e/img2.webp')`}}></div>
            <div className="gridBox__item gridBox__item_3">
              <img src="/cases/img/quall-e/img3.webp" alt="" />
              <img src="/cases/img/quall-e/logo-orange.svg" alt="" className="gridBox__logo" />            
            </div>
            <div className="gridBox__item gridBox__item_4">
              <img src="/cases/img/quall-e/img4.webp" alt="" />
              <img src="/cases/img/quall-e/logo-white.svg" alt="" className="gridBox__logo" />  
            </div>
            <div className="gridBox__item gridBox__item_5" style={{backgroundImage: `url('/cases/img/quall-e/img5.svg')`}}></div>
            <div className="gridBox__item gridBox__item_6">
              <div className="logoBlock">
                <div className="logoBlock__item">QUALL</div>
                <div className="logoBlock__item"><img src="/cases/img/quall-e/ball.webp" alt="" /></div>
                <div className="logoBlock__item">E</div>
              </div>
            </div>
            <div className="gridBox__item gridBox__item_7" style={{backgroundImage: `url('/cases/img/quall-e/img6.webp')`}}></div>
            <div className="gridBox__item gridBox__item_8">
              <div>Здравствуйте, <br/>я <span>AI ассистент</span> и сохраню <span>дo 80%</span> вашего времени.</div>
            </div>
            <div className="gridBox__item gridBox__item_9">
              <div className="colors">
                <div>#F6F8F7</div>
                <div>#EEEEEE</div>
                <div>#DFDFDF</div>
                <div>#0F0E12</div>
                <div>#FA6F33</div>
              </div>
            </div>            
          </div>
        </div>
        <div className="screen workType">
          <div className="content">
            <div className="workType__wrap">
              <div className="workType__title title">Сайт</div>
              <div className="workType__desc text">
                Сайт AI-ассистента Quall-e выполнен в современном минималистичном стиле с яркими акцентами. Чистый дизайн, крупная типографика и продуманная цветовая схема делают информацию легко воспринимаемой.
                <br/><br/>
                Сайт наглядно раскрывает возможности AI-помощника для поиска клиентов в недвижимости. Визуально демонстрируется, как ассистент взаимодействует с пользователями, эффективно обрабатывая запросы. Удобная навигация помогает быстро разобраться в преимуществах технологии.
              </div>
            </div>
          </div>
        </div>
        <div className="screen">
          <div className="gridBox gridBox_site">
            <div className="gridBox__item gridBox__item_1"><img src="/cases/img/quall-e/img7.webp" alt="" /></div>
            <div className="gridBox__item gridBox__item_2">
              <div className="gridChild2">
                <div className="gridChild2__item gridChild2__item_1">
                  <div className="benefitBloks">
                    <div className="benefitBloks__item">
                      <div className="benefitBloks__title">Работаю <br/>в&nbsp;вашей среде</div>
                      <div className="benefitBloks__text">Интеграция c WhatsApp, Telegram,  электронной почтой, Google таблицами или&nbsp;с&nbsp;вашей CRM </div>
                      <img src="/cases/img/quall-e/img15.svg" alt="" />
                    </div>
                    <div className="benefitBloks__item">
                      <div className="benefitBloks__title">Говорю <br/>на&nbsp;любом языке</div>
                      <div className="benefitBloks__text">Общайтесь без&nbsp;усилий на&nbsp;выбранном вамиsязыке, преодолевая языковой барьер</div>
                      <img src="/cases/img/quall-e/img16.svg" alt="" />
                    </div>
                    <div className="benefitBloks__item">
                      <div className="benefitBloks__title">Работаю <br/>в&nbsp;любой стране</div>
                      <div className="benefitBloks__text">Доступен по&nbsp;всему миру, обслуживая каждый уголок земного шара</div>
                      <img src="/cases/img/quall-e/img17.svg" alt="" />
                    </div>
                  </div>
                </div>
                <div className="gridChild2__item gridChild2__item_2">
                  <div className="bubbles">
                    <img src="/cases/img/quall-e/bubble1.webp" alt=""  className="bubbles_1" />
                    <img src="/cases/img/quall-e/bubble2.webp" alt=""  className="bubbles_2" />
                    <img src="/cases/img/quall-e/bubble3.webp" alt=""  className="bubbles_3" />
                  </div>
                </div>             
              </div>
            </div>
            <div className="gridBox__item gridBox__item_3" style={{backgroundImage: `url('/cases/img/quall-e/img8.webp')`}}></div>
            <div className="gridBox__item gridBox__item_4" style={{backgroundImage: `url('/cases/img/quall-e/img9.webp')`}}></div>
            <div className="gridBox__item gridBox__item_5">
              <div className="videoBlock">
                <div className="videoBlock__btn" style={{ backgroundImage: `url('/cases/img/quall-e/play.svg')` }}></div>
                <video id="video" poster="/cases/img/quall-e/poster.webp" loop preload="metadata">
                  <source src="/cases/img/quall-e/video.mp4" type="video/mp4"></source>
                </video>
              </div>                
            </div>
            <div className="gridBox__item gridBox__item_6">
              <div className="gridSmall">
                <div className="gridSmall__img"><img src="/cases/img/quall-e/img10.webp" alt="" /></div>
                <div className="gridSmall__text text">
                  Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко всем необходимым функциям в любое время и в любом месте. 
                  <br/><br/>
                  Интерфейс оптимизирован для удобства использования на мобильных устройствах, что делает навигацию простой и интуитивной. При этом визуальный дизайн сохраняет эстетическую привлекательность, отражая фирменный стиль проекта и создавая гармоничное восприятие даже на&nbsp;небольших экранах.
                </div>
              </div>
            </div>
            <div className="gridBox__item gridBox__item_7">
              <img src="/cases/img/quall-e/img11.webp" alt="" />
              <img src="/cases/img/quall-e/img12.webp" alt="" />
              <img src="/cases/img/quall-e/img13.webp" alt="" />
              <img src="/cases/img/quall-e/img14.webp" alt="" />
            </div>
          </div>
        </div>
			</div>

  

    <CaseFooterNew 
				to={ this.props.next ? this.props.next.url: "/projects/dreamriva/"  }
				title= { this.props.next ? this.props.next.name: `Жилой комплекс “Dream Riva”`   } 
				img={ this.props.next ? this.props.next.imgCaseBottom: "/cases/img/dreamriva/dreamriva.webp" }
        full={true}
			/>
      <HelmetSite title='AI ассистент “Quall-e”' />

			<div className="case-info">
				<Link to="/projects/" className="all-title">Все проекты</Link>
				<div className="title">Жилой комплекс “Dream Riva”</div>
				<div className="tags"><span>фирменный стиль</span><span>сайт</span></div>
			</div>
		</div>
		)
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Qualle)
